import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing getCities model
import { getTags } from 'models/tags'; // Importing getTags model
import { getPositions } from 'models/positions'; // Importing getPositions model
import { devConfig, profile } from 'config/config'; // Importing devConfig and profile from config
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing Webix TinyMCE module

/**
 * Class representing the FilterWithdrawalRequestView.
 * @extends JetView
 */
export default class FilterWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        // Left section containing various input fields for filtering
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for date selection
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker component
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum date selectable is today
                                },
                            },
                        },
                        {
                            view: 'richselect', // Dropdown for selecting state
                            name: 'State',
                            minWidth: 200,
                            localId: 'bonusStates:combo',
                            value: 'I', // Default selected value
                            label: _("<span class='icon-state'></span> Estado"), // Label for the state selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                {
                                    id: 'I',
                                    value: _('Pagado'), // Option for 'Paid'
                                },
                            ],
                        },
                        {
                            view: 'radio', // Radio buttons for commission selection
                            name: 'MyCommission',
                            label: _('Mi comisión'), // Label for the radio group
                            labelPosition: 'top',
                            value: 2, // Default selected value
                            options: [
                                { id: 1, value: _('Sí') }, // Option for 'Yes'
                                { id: 2, value: _('No') }, // Option for 'No'
                            ],
                        },
                        {
                            margin: 15,
                            css: 'on-row',
                            cols: [
                                {
                                    view: 'checkbox', // Checkbox for commission date filter
                                    label: _('Por fecha de comisión pagado'),
                                    labelPosition: 'top',
                                    name: 'ByAllowDate',
                                    value: 0, // Default unchecked value
                                    minWidth: 200,
                                },
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for selecting commission type
                            name: 'ComissionsType',
                            label: _('Tipo de comisión'), // Label for the commission type selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: 'ALL', // Default selected value
                            options: [
                                { id: 'ALL', value: _('Todos') }, // Option for 'All'
                                { id: 'SPORTNGRAFF', value: _('SPORTNGRAFF') },
                                { id: 'DEPOSITOAFF', value: _('DEPOSITOAFF') },
                                { id: 'SPORTPVIP', value: _('SPORTPVIP') },
                                { id: 'SPORTPV', value: _('SPORTPV') },
                                { id: 'DEPOSITOPV', value: _('DEPOSITOPV') },
                                { id: 'BETSPORTPV', value: _('BETSPORTPV') },
                                { id: 'RETIROSPV', value: _('RETIROSPV') },
                                { id: 'SPORTAFF', value: _('SPORTAFF') },
                                {
                                    id: 'CASINONGRAFF',
                                    value: _('CASINONGRAFF'),
                                },
                                {
                                    id: 'DEPOSITOPVXTR',
                                    value: _('DEPOSITOPVXTR'),
                                },
                                { id: 'BETSPORTAFF', value: _('BETSPORTAFF') },
                                { id: 'WINSPORTAFF', value: _('WINSPORTAFF') },
                                { id: 'CASINOAFF', value: _('CASINOAFF') },
                                { id: 'WINSPORTPV', value: _('WINSPORTPV') },
                                { id: 'CASINOPV', value: _('CASINOPV') },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for user ID
                            minWidth: 200,
                            name: 'UserId',
                            type: 'text',
                            labelPosition: 'top',
                            label: _('ID Usuario'), // Label for user ID input
                            placeholder: _('ID Usuario'), // Placeholder text
                        },
                        {
                            view: 'richselect', // Dropdown for selecting user type
                            name: 'UserType',
                            label: _('Tipo de usuario'), // Label for user type selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: 'ALL', // Default selected value
                            options: [
                                { id: 'ALL', value: _('Todos') }, // Option for 'All'
                                { id: 'AF', value: _('Afiliador') }, // Option for 'Affiliate'
                                { id: 'CO', value: _('Concesionario') }, // Option for 'Concessionaire'
                                { id: 'SC', value: _('Subconcesionario') }, // Option for 'Sub-concessionaire'
                                { id: 'PV', value: _('Punto de Venta') }, // Option for 'Point of Sale'
                            ],
                        },
                        {
                            view: 'text', // Text input for concessionaire ID
                            minWidth: 200,
                            name: 'ConcessionaireId',
                            type: 'text',
                            labelPosition: 'top',
                            label: _('ID Concesionario'), // Label for concessionaire ID input
                            placeholder: _('ID Concesionario'), // Placeholder text
                        },
                        {
                            view: 'checkbox', // Checkbox for summary view
                            label: _('Visualización resumida'),
                            labelPosition: 'top',
                            name: 'Type',
                            id: 'Type',
                            value: 0, // Default unchecked value
                            minWidth: 200,
                        },
                    ],
                },
            ],
        };

        // Upper section containing the left filter inputs
        const upper_section = {
            css: 'father-container',
            id: 'upper_section',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Including the left section
                },
            ],
        };

        // Button section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav1', gravity: 4 }, // Spacer
                        {
                            view: 'button', // Button to clear filters
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 130,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear the form inputs
                            },
                        },
                        {
                            view: 'button', // Button to submit filters
                            value: _('Consultar'),
                            hotkey: 'enter', // Enter key to trigger
                            width: screen == 'small' ? 0 : 130,
                            minWidth: 200,
                            type: 'form',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove Date if typeDate is not 2
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                                    }
                                }
                                this.app.callEvent('withdrawalReport:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                                $$('b5').collapse(); // Collapse the accordion section
                            },
                        },
                    ],
                },
            ],
        };

        // Second button section for actions
        const buttons2 = {
            margin: 10,
            cols: [
                {
                    view: 'button', // Button to clear filters in the second form
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset form values
                        $$('Datepicker').setValue(''); // Clear datepicker value
                    },
                },
                {
                    view: 'button', // Button to submit filters in the second form
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key to trigger
                    type: 'form',
                    width: 110,
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('withdrawalReport:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                    },
                },
            ],
        };

        // Accordion section for filters
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion component for collapsible sections
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Including upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section for the second form
        const accordion_section3 = {
            padding: 10,
            rows: [upper_section, buttons2], // Including upper section and second buttons
        };

        // Popup window for filters
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the popup
                    {
                        view: 'icon', // Close icon for the popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3], // Including the accordion section
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
                },
            },
        });

        // Main return object for the view
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion section if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder for small screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal configuration based on language
        });
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date input if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date input if condition is true
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
    }
}

// FILE DOCUMENTED
